import { render, staticRenderFns } from "./ticketsSoldHistory.vue?vue&type=template&id=5f7d7b36&scoped=true&"
import script from "./ticketsSoldHistory.vue?vue&type=script&lang=js&"
export * from "./ticketsSoldHistory.vue?vue&type=script&lang=js&"
import style0 from "./ticketsSoldHistory.vue?vue&type=style&index=0&id=5f7d7b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7d7b36",
  null
  
)

export default component.exports